import { useTranslation } from 'react-i18next'
import { WidgetSection } from '../../../../rapid-ui'
import { MetaOverlayConfiguration } from '../../../../views/shared/conformed/common'
import type { SimulatorType } from '../../../tracking'
import { trackOverlayEdited } from '../../../tracking'
import { ProOverlayEditor } from './pro-mode'
import { SimpleOverlayEditor } from './simple-mode'

export type OverlayEditorProps = {
	overlay: MetaOverlayConfiguration
	onChange: (overlay: MetaOverlayConfiguration) => void

	proMode: boolean
	onProModeChange: (proMode: boolean) => void

	simulatorType: SimulatorType
}

export function OverlayEditor({ overlay, onChange, proMode, onProModeChange, simulatorType }: OverlayEditorProps) {
	const { t } = useTranslation('common')
	return (
		<WidgetSection
			label={t('editor.overlay.options')}
			mode={proMode ? 'pro' : 'simple'}
			onModeChange={(mode) => {
				trackOverlayEdited('mode_toggle', simulatorType)
				onProModeChange?.(mode === 'pro')
			}}
		>
			{({ mode }) => (
				<>
					{mode === 'simple' && (
						<SimpleOverlayEditor overlay={overlay} onChange={onChange} simulatorType={simulatorType} />
					)}
					{mode === 'pro' && (
						<ProOverlayEditor overlay={overlay} onChange={onChange} simulatorType={simulatorType} />
					)}
				</>
			)}
		</WidgetSection>
	)
}
